class TcEmailController {
  constructor($element, $scope, $timeout) {
    "ngInject";
    this.$element = $element;
    this.$scope = $scope;
    this.$timeout = $timeout;
  }

  $onInit() {
    // Initialize if ngModel has a value
  }

  $onChanges(changes) {
    // Handle changes if needed
  }

  isValidEmail() {
    if (!this.ngModel) {
      return !this.required; // Empty is valid if not required
    }
    
    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.ngModel);
  }
}

export default TcEmailController;




// WEBPACK FOOTER //
// ./client/common/directives/email/tc-email.controller.js